module.exports = __webpack_public_path__ + "static/media/personality Disorder.3efa1167.svg";